import React from 'react'
import { PiCalendarCheck } from 'react-icons/pi'
import useAppContext from '../../hook/useAppContext'
import HeaderPage from '../../components/headerpage/HeaderPage'
import SharePostAction from './SharePostAction'
import Empty from '../../components/empty/Empty'
import './posts.css'

const Posts = ({current}) => {

      const {user, timeAgo, post_at, break_line} = useAppContext()
      const {posts} = user 

      if(current !== 'posts') return 

      if(posts.code){
            return (
                  <Empty title={"Posts"} desc={"Oops, there are no articles published yet."}/>
            )
      }

      return (
            <div className="page_group">
                  {
                        posts.map((item, index) => (
                              <div className="card_post" key={index}>
                                    <HeaderPage desc={timeAgo(item.post_at)} />
                                    <div className="card_post__box">
                                          <div className="card_post__cover flex">
                                                <img src={item.cover} alt={item.title} />
                                          </div>
                                          <div className="card_post__content">
                                                <div className="card_post__title">
                                                      <h2>{item.title}</h2>
                                                </div>
                                                <div className="card_post__description">
                                                      <p>{break_line(item.content)}</p>
                                                </div>
                                                <div className="card_post__action flex">
                                                      <SharePostAction item={item}/>
                                                      <div className="card_post__at flex">
                                                            <div className="post_at__icon">
                                                                  <PiCalendarCheck />
                                                            </div>
                                                            <span>{post_at(item.post_at)}</span>
                                                      </div>
                                                </div>
                                                
                                          </div>
                                    </div>
                              </div>
                        ))
                  }
                  
            </div>
      )
}

export default Posts
